import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { CONNECTIONS_STATUS_QUERY_KEY } from "@/components/channel-connect/connections-status-query";
import { WS_CONNECTION_HEALTH_EVENT } from "@/lib/ws-events";

/**
 * Invalidates connection status queries when the server broadcasts connection_health_changed.
 */
export function useConnectionHealthInvalidation(studioId: string | undefined) {
  const queryClient = useQueryClient();

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<{ studioId?: string }>).detail;
      const targetStudioId = detail?.studioId ?? studioId;
      if (!targetStudioId) return;
      void queryClient.invalidateQueries({
        queryKey: [CONNECTIONS_STATUS_QUERY_KEY, targetStudioId],
      });
    };

    window.addEventListener(WS_CONNECTION_HEALTH_EVENT, handler);
    return () => window.removeEventListener(WS_CONNECTION_HEALTH_EVENT, handler);
  }, [queryClient, studioId]);
}
